import { c as _c } from "react/compiler-runtime";
import type { ApiIdentityAndSubscriptionActions } from "@/generated/models/ApiIdentityAndSubscriptionActions";
import Follower from "./Follower";
export default function FollowersList(t0) {
  const $ = _c(7);
  const {
    followers,
    showFollowButtons: t1
  } = t0;
  const showFollowButtons = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== followers || $[1] !== showFollowButtons) {
    let t3;
    if ($[3] !== showFollowButtons) {
      t3 = (follower, index) => <Follower key={follower.identity.id} follower={follower} showFollowButton={showFollowButtons} mutedBackground={index % 2 === 1} />;
      $[3] = showFollowButtons;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = followers.map(t3);
    $[0] = followers;
    $[1] = showFollowButtons;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="tw-mt-4 tw-flex tw-h-full tw-flex-col tw-overflow-hidden">{t2}</div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}